<template>
<!--単純に絵を拡大表示するコンポーネントを作りたい

モジュールで提供されるものは、
機能が過剰
設置表記が特殊
なのがネック。

通常の表記のままで、指定フラグ記載で拡大機能を行うように作りたい。
<a>で囲まずに済む対応
<img src="サムネイルURL" alt="" data-image="拡大用URL" role="button" tabIndex={0} @click="openOverView">

各ページコンポーネントに組み込む処理
import OverView from '@/components/OverView.vue'

  components:{
    'over-view':'OverView',
  },
  methods:{
/*ルートで定義*/
    overView:function(event) {
      let imageUrl = event.target.dataset.image
      let imageAlt = event.target.getAttribute('alt')
    }
  },

-->
  <div class="overView" @click='deleteSelf'>
    <button @click='deleteSelf'><img src="/asset/images/components/overView/closeView.svg" alt="閉じるボタン"></button>
    <p>
<!--				<img :src="image_path(imageUrl)" :alt='imageAlt'>-->

			<pdf v-if="isPdf" :src="imageUrl"></pdf>
			<video v-else-if="isMov" autoplay loop muted :src="imageUrl" type="video/mp4"></video>
			<img v-else :src="imageUrl" :alt="imageAlt" class="" role="button" tabIndex={0} >
    </p>
  </div>

</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'overview',
  props:{
    imageUrl:{type:String},
    imageAlt:{type:String},
  },
  data() {
    return {
    }
  },
  computed:{
    webpackUrl:function() {
      let url = require(this.imageUrl)
      return url
    },
    isPdf:function() {
      return !(this.imageUrl.toLowerCase().indexOf(".pdf") === -1)
    },
    isMov:function() {
      return !(this.imageUrl.toLowerCase().indexOf(".mp4") === -1)
    },
  },
  components: {
    pdf,
  },
  methods:{
    deleteSelf: function () {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    image_path: function(aUrl){
      let res = aUrl
/* src/asset @指定の場合は、reqquireをする > 動かない・・*/
      if( aUrl.indexOf('@') !== -1) {
        res = require(aUrl)
      }
/*現在はそのまま設定をそのままかえすだけ*/
      return res
    }
  },
}
</script>

<style>
.overView {
  display:flex;
  justify-content:center;
  align-items:center;

  position:fixed;
  top:0;
  left:0;
  z-index:9999;
  width:100%;
  height:100vh;
  background:rgba(0,0,0,.5);

  opacity:0;
  animation:appearView .8s ease forwards;
}
.overView>button{
  position:absolute;
  top:0;
  right:0;
/*
  left:50%;
  transform:translateX(-50%);
*/
  width:60px;
  height:60px;
  padding:0;
  background:#ccc;
  border:0;

  transition:all 0.8s ease;
}
.overView>button:hover{
  background:#fff;
}


.overView>p{
  width:auto !important;
  padding:1em !important;
  margin:0 !important;
}
.overView>p>*{
  max-width:100vw;
  max-height:100vh;
}

@keyframes appearView {
  0% {
    opacity:0;
  }
  96% {
    opacity:1;
  }
  100% {
    opacity:1;
  }
}

</style>